import React from "react";
import PageBanner from "../../components/TermsPageComponents/PageBanner";
import { pgImg6, securityProcess } from "../../components";

function PenetrationTestingService() {
  return (
    <>
      <section id="securityServicesPage" className="securityServicesPage">
        <div className="pagesBanner">
          <PageBanner PageTitle="Penetration Testing Service" />

          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
      </section>
      <section
        id="securityServicesContentWrap"
        className="securityServicesContentWrap"
      >
        <div className="container">
          <div className="col-md-12 col-12">
            <div className="contentWrap">
              <p>
                Penetration testing stands as a highly effective means of
                identifying vulnerabilities in your system. Yet, to carry out an
                exceptionally advanced penetration test, you require the
                expertise of a proficient security service provider like Version
                Next Technologies. Numerous other service providers make grand
                claims but often fall short in delivering. Our esteemed
                clientele serves as a testament to the excellence we
                consistently deliver through our services.
              </p>
              <p>
                While there are numerous VAPT services available in Mumbai, what
                truly distinguishes us is our exceptional capacity to perform
                penetration testing at a level unmatched by other security
                firms. We take great pride in having some of the most brilliant
                security experts leading our efforts, capable of undertaking any
                security assessment test to fortify your business's security.
                Our tests encompass nearly all vulnerabilities that a hacker
                might potentially exploit, ensuring comprehensive protection for
                your business.
              </p>

              <div className="mbClass">
                <div className="sedtionTitle">
                  <h4 className="text-center">
                    Our VAPT Certification Methodology
                  </h4>
                </div>
                <div className="pageImgWrap">
                  <img
                    src={securityProcess}
                    alt="Our VAPT Certification Methodology"
                  />
                </div>
              </div>
              <p>
                We employ the most advanced penetration testing tools available
                in the security industry to ensure that no vulnerabilities are
                left exposed to potential hackers. Our esteemed clientele has
                consistently benefited from our top-tier services. We place a
                strong emphasis on providing high-quality services at highly
                competitive prices. Rest assured, your company's IT security is
                our top priority, and we offer a comprehensive range of services
                to maintain its integrity. From IT security audits to VAPT tests
                and even web application security, Version Next Technologies
                covers it all. Our domain experts are seasoned professionals you
                can trust not to disappoint.
              </p>
              <div className="row">
                <div className="col-md-5 mx-auto my-0">
                  <div className="pageImgWrap">
                    <img src={pgImg6} alt="Penetration Testing Service" />
                  </div>
                </div>
              </div>
              <p>
                Neglecting your company's IT security leaves it vulnerable to
                potential hackers who may exploit security gaps to access your
                confidential data—a situation no business desires. Entrust
                Version Next Technologies to manage your company's IT security;
                we are the premier VAPT company in Mumbai. Our advanced
                penetration testing will uncover vulnerabilities in your
                company's IT systems and architecture, providing you with
                essential insights to bolster your security.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PenetrationTestingService;
